import { Component, OnInit } from '@angular/core';
import { combineAll, DcBaseComponent } from '@datachain/ui-sdk/common';
import { BehaviorSubject, Observable } from 'rxjs';

import { Configuration } from '../../../ui/components/app-permissions-configurator/app-permissions-config.component';
import { PermissionConfigItemEntity } from '../../../ui/components/app-permissions-configurator/permission-config-item.entity';
import { PermissionConfigListEntity } from '../../../ui/components/app-permissions-configurator/permission-config-list.entity';
import { PermissionConfigListProvider } from './permission-config-list.provider';

@Component({
	selector: 'app-permission-list',
	templateUrl: './permission-list.component.html',
	styleUrls: ['./permission-list.component.scss'],
	providers: [PermissionConfigListProvider],
})
export class PermissionListComponent extends DcBaseComponent implements OnInit {
	public vo$: Observable<{
		list: PermissionConfigListEntity;
		result: Array<PermissionConfigItemEntity>;
	}>;

	private readonly result$ = new BehaviorSubject<
		Array<PermissionConfigItemEntity>
	>([]);

	public config: Configuration = {
		usePanel: true,
		columnWidth: 250,
		inViewMode: false,
	};

	public constructor(
		private readonly permissionProvider: PermissionConfigListProvider
	) {
		super();
		this.cmpId = 'app-permission-list';

		const list = this.permissionProvider.setAutoElements();

		this.vo$ = combineAll({
			list,
			result: this.result$,
		});
	}

	public ngOnInit(): void {
		super.ngOnInit();
	}

	public getResult(list: PermissionConfigListEntity): void {
		this.result$.next(Array.from(list.elements.values()));
	}
}
